<template>
  <q-checkbox
    dense
    :label="label !== undefined ? String(label) : undefined"
    :class="{
      'incredi-checkbox-disabled': $attrs.disable,
    }"
    class="incredi-checkbox ibf-h5"
    :size="'36px'"
    :for="labelFor"
    center
    v-bind="$attrs"
    :model-value="$attrs.modelValue || value"
    @update:modelValue="
      newValue => {
        $emit('input', newValue);
        $emit('update:value', newValue);
      }
    "
  />
</template>

<script>
export default {
  name: 'IncrediCheckBox',
  props: {
    value: {},
    labelFor: {
      type: String,
    },
    label: {
      type: [String, Number],
    },
  },
};
</script>

<style lang="scss">
.incredi-checkbox {
  &.disabled {
    .q-checkbox__bg {
      border: 2px solid $-system-app-grey-91;
      color: $-system-app-grey-91 !important;
    }
  }
  .q-checkbox__bg {
    color: $-system-app-primary;
    border: 2px solid $-system-app-primary;
  }
  .q-checkbox__inner--falsy .q-checkbox__bg {
    background: $-system-app-white;
  }
}
</style>
